import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { hasPrivilege } from '../helpers/hasPrivilege';

interface PrivateRouteWithPrivilegeProps {
  children: React.ReactNode;
  vgroup: string;
  action?: string;
  applicationType?: string;
}

const PrivateRouteWithPrivilege: React.FC<PrivateRouteWithPrivilegeProps> = ({ 
  children, 
  vgroup,
  action = 'view',
  applicationType = 'Admin Transmora'
}) => {
  const { profile } = useSelector((state: any) => state.auth);

  const hasAccess = hasPrivilege(profile, vgroup, action);

  if (!hasAccess) {
    console.log(`Route Access DENIED: ${applicationType}.${vgroup}.${action}`);
    return <Navigate to="/unauthorized" replace />;
  }

  console.log(`Route Access GRANTED: ${applicationType}.${vgroup}.${action}`);
  return <>{children}</>;
};

export default PrivateRouteWithPrivilege;